/*
 * @Author: wang.jiang
 * @Date: 2016-3-1
 * @LastEditTime: 2021-04-08 15:09:11
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\operateCenter\operateCenterRouter.js
 * @Description:  运营中心主路由
 */
'use strict';
angular.module('operpateCenterRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.operatecenter', {
            url: '/operatecenter',
            views: {
                'main@front': {
                    templateUrl: './operateCenter/index_tpl.html',
                    // controller: 'operateCenterCtrl'
                },
                'main@front.operatecenter': {
                    templateUrl: './operateCenter/main_tpl.html',
                },
            }
        });
    }]);
